import { initializeApp } from "firebase/app";
import {
  Auth,
  GoogleAuthProvider,
  User,
  getAuth,
  onAuthStateChanged,
  signInWithPopup,
  signOut
} from "firebase/auth";

import { AppCfg } from "@/shared/config/app";

class FirebaseService {
  private _auth: Auth;
  constructor() {
    const app = initializeApp(AppCfg.firebase);
    const auth = getAuth(app);
    this._auth = auth;
  }

  get currentUser(): User | null {
    return this._auth.currentUser;
  }

  onAuthStateChanged(callback: (user: User | null) => void) {
    return onAuthStateChanged(this._auth, callback);
  }

  async signIn() {
    const provider = new GoogleAuthProvider();
    await signInWithPopup(this._auth, provider);
  }

  async signOut() {
    await signOut(this._auth);
  }

  async getIdToken(): Promise<string | null> {
    try {
      return (await this._auth.currentUser?.getIdToken()) ?? null;
    } catch (e) {
      if (e instanceof Error && e.message === "No user is signed in.") {
        // NOTE: IGNORE this error
        return null;
      }
      console.log("[DEBUG] FirebaseService.getIdToken - error:", e);
      return null;
    }
  }
}

export const firebaseService = new FirebaseService();
